import useCustomerBiometry from '~/store-v2/contract-formalization/useCustomerBiometry'
import useFinancing from '~/store-v2/financings/useFinancing'
import useHardwareHistory from '~/store-v2/installation/useHardwareHistory'

export function usePendingUpdateEquipment(projectId: Ref<string>) {
  const { data: financing } = useFinancing(projectId)

  const isContractStepAvailable = computed(() => {
    return !!financing.value?.openable_steps?.contract
  })

  const { data: hardwareHistory, isLoading: isLoadingHistory, refetch: refetchHardwareHistory } = useHardwareHistory(projectId)
  const { data: customerBiometry } = useCustomerBiometry(projectId, isContractStepAvailable)

  const pendingUpdateEquipment = computed(() => {
    if (isLoadingHistory.value) return null

    const history = hardwareHistory.value?.data?.history
    if (!history || history.length === 0) return null

    return history.find(item => item.status === 'pending') || null
  })

  const hasTAFInProgress = computed(() => {
    const tafContracts = customerBiometry.value?.contracts?.financing_amendment_term as
      | Array<{ status?: string }>
      | { status?: string }
      | null
      | undefined

    if (!tafContracts || (Array.isArray(tafContracts) && tafContracts.length === 0)) {
      return false
    }

    const pendingStatuses = ['in_progress', 'waiting']

    if (Array.isArray(tafContracts)) {
      return tafContracts.some(taf => pendingStatuses.includes(taf?.status || ''))
    }

    return pendingStatuses.includes(tafContracts?.status || '')
  })

  const hasPendingTAF = computed(() => {
    return Boolean(pendingUpdateEquipment.value) || hasTAFInProgress.value
  })

  watch(hasTAFInProgress, (newValue, oldValue) => {
    if (oldValue && !newValue) {
      refetchHardwareHistory()
    }
  })

  return {
    pendingUpdateEquipment,
    hasPendingTAF,
    isLoading: isLoadingHistory,
  }
}
